/**
 * Semáforo de performance (PRD §15 e Anexo B). As faixas são configuráveis por empresa e por KPI
 * (motor de cálculo na T-061); aqui ficam só os estados e seus rótulos.
 */
export const TRAFFIC_LIGHTS = ['green', 'yellow', 'red', 'gray', 'blue'] as const;
export type TrafficLight = (typeof TRAFFIC_LIGHTS)[number];

export const TRAFFIC_LIGHT_LABELS: Record<TrafficLight, string> = {
  green: 'No alvo',
  yellow: 'Atenção',
  red: 'Crítico',
  gray: 'Sem dados',
  blue: 'Planejado',
};

/** Explicação curta de cada estado, para dicas e legendas. */
export const TRAFFIC_LIGHT_DESCRIPTIONS: Record<TrafficLight, string> = {
  green: 'Dentro ou acima da meta',
  yellow: 'Faixa de atenção',
  red: 'Faixa crítica',
  gray: 'Sem resultado lançado no período',
  blue: 'Período futuro ou em planejamento',
};
